import { createFileRoute } from "@tanstack/react-router";

import { Flow } from "~/components/feature/flow";

export const Route = createFileRoute("/_app/dashboard/flow")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Flow />;
}
